import { render } from "./TvmLoaderModal.vue?vue&type=template&id=146fa39a"
import script from "./TvmLoaderModal.vue?vue&type=script&lang=js"
export * from "./TvmLoaderModal.vue?vue&type=script&lang=js"

import "./TvmLoaderModal.vue?vue&type=style&index=0&id=146fa39a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__